import React, { ComponentProps, PropsWithChildren } from 'react';
import { Box } from '../../legacy/Box';
import { Popover } from '../Popover';
import { Text } from '../Text';
import css from './index.module.scss';
import { TooltipProps } from './types';

interface TooltipPopoverProps
  extends Omit<TooltipProps, 'children' | 'anchor'>,
    Pick<ComponentProps<typeof Popover>, 'anchor' | 'open'> {
  hideTooltip: () => void;
  persistTooltip: () => void;
}

export const TooltipPopover: React.FC<PropsWithChildren<TooltipPopoverProps>> = ({
  anchor,
  disablePadding,
  maxWidth = 284,
  variant = 'dark',
  placement = 'top',
  offset = 2,
  open,
  tooltipContent,
  hideTooltip,
  persistTooltip,
  compact,
  ...rest
}) => (
  <Popover
    data-component="TooltipPopover"
    anchor={anchor}
    open={open}
    variant={variant}
    placement={placement}
    offset={offset}
    arrow={!compact}
    maxWidth={maxWidth}
    {...rest}
  >
    <Box
      className={css.content}
      padding={compact ? 4 : !disablePadding ? [8, 12] : undefined}
      onMouseEnter={persistTooltip}
      onMouseLeave={hideTooltip}
      maxWidth={1}
    >
      {typeof tooltipContent === 'string' ? (
        <Text color={variant === 'dark' ? 'default-inverse' : 'default'} appearance="bodySmall">
          {tooltipContent}
        </Text>
      ) : (
        tooltipContent
      )}
    </Box>
  </Popover>
);
